import {
  FeedstockBmpPotentialYield,
  FeedstockBmpPotentialYieldPropName
} from '../../../../../models/project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-potential-yield.model';
import { ValidationInterface } from '../../../validation.interface';
import { ProjectValidationUnit } from '../../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../../unit-value.validation';

export class FeedstockBmpPotentialYieldValidation implements ValidationInterface {
  /** The current BMP potential yield obj that is being validated */
  bmpPotentialYield: FeedstockBmpPotentialYield;

  /**
   * Sets the BMP potential yield that will be used for validation
   * @param bmpPotentialYield will be used to set the current BMP yield obj
   */
  constructor(bmpPotentialYield: FeedstockBmpPotentialYield) {
    if (!bmpPotentialYield) throw Error('invalid BMP potential yield provided for validation');
    this.bmpPotentialYield = new FeedstockBmpPotentialYield(bmpPotentialYield);
  }

  /**
   * Get a validation unit containing the validation data for the current BMP potential yield obj
   * @param validationUnit, if provided will have the validation for the current BMP potential yield
   * added to it. If it is not provided a new validation unit will be returned.
   */
  getValidation(validationUnit = new ProjectValidationUnit()): ProjectValidationUnit {
    if (!this.bmpPotentialYield) throw Error('unable to validate BMP potential yield');
    if (this.bmpPotentialYield.yieldType) {
      validationUnit.setValid(FeedstockBmpPotentialYieldPropName.yieldType);
    } else {
      validationUnit.setInvalid(
        FeedstockBmpPotentialYieldPropName.yieldType,
        [FeedstockBmpPotentialYieldError.MISSING_YIELD_TYPE]
      );
    }
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialYield.yield).getValidation(),
      FeedstockBmpPotentialYieldPropName.yield
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialYield.ch4Concentration).getValidation(),
      FeedstockBmpPotentialYieldPropName.ch4Concentration
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialYield.period).getValidation(),
      FeedstockBmpPotentialYieldPropName.period
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current BMP potential yield obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}

/**
 * An enum that contains errors for BMP potential yield validation
 */
export enum FeedstockBmpPotentialYieldError {
  MISSING_YIELD_TYPE = 'VALIDATION.MISSING_YIELD_TYPE'
}
